import { render, staticRenderFns } from "./BusinessDocumentList.vue?vue&type=template&id=21ea3970&scoped=true&"
import script from "./BusinessDocumentList.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDocumentList.vue?vue&type=style&index=0&id=21ea3970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea3970",
  null
  
)

export default component.exports